import { render, staticRenderFns } from "./buyPrice.vue?vue&type=template&id=029756a9&scoped=true"
import script from "./buyPrice.vue?vue&type=script&lang=js"
export * from "./buyPrice.vue?vue&type=script&lang=js"
import style0 from "./buyPrice.vue?vue&type=style&index=0&id=029756a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029756a9",
  null
  
)

export default component.exports